export class State {
  short: string;
  title: string;

  constructor() {
    this.short = "";
    this.title = "";
  }
}
